import { FontStyle, FontWeight } from '@genesislcap/foundation-utils';
import { neutralFillStealthActive, neutralForegroundRest } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { display, forcedColorsStylesheetBehavior } from '@microsoft/fast-foundation';
import { SystemColors } from '@microsoft/fast-web-utilities';
import { loadRobotoFontFaces, mixinRobotoFont } from '../_config/styles/external/roboto-font';
loadRobotoFontFaces();
const baseStyles = css `
  ${display('flex')}
  :host {
    flex: 1;
  }
`;
const backgroundStyles = css `
  :host {
    background-color: ${neutralFillStealthActive};
  }
`.withBehaviors(forcedColorsStylesheetBehavior(css `
    :host {
      background-color: ${SystemColors.ButtonFace};
      box-shadow: 0 0 0 1px ${SystemColors.CanvasText};
      color: ${SystemColors.ButtonText};
    }
  `));
const getHeaderForContext = (context, headingLevel, typeRampValue) => css `
  ${context.name} ${'h' + headingLevel} {
    font-size: var(--type-ramp-plus-${typeRampValue}-font-size);
    line-height: var(--type-ramp-plus-${typeRampValue}-line-height);
    margin: 0;
    ${mixinRobotoFont(FontStyle.Normal, FontWeight.Bold)}
  }
`;
const typography = (context) => css `
  ${getHeaderForContext(context, '1', '6')}
  ${getHeaderForContext(context, '2', '5')}
  ${getHeaderForContext(context, '3', '4')}
  ${getHeaderForContext(context, '4', '3')}
  ${getHeaderForContext(context, '5', '2')}
  ${getHeaderForContext(context, '6', '1')}
`;
export const designSystemProviderStyles = (context) => {
    const contextualizedTypography = typography(context);
    // Document-level but contextualized overrides (h1, h2, span, etc)
    contextualizedTypography.addStylesTo(document);
    return css `
    ${baseStyles}
    ${backgroundStyles}
    ${contextualizedTypography}
    :host * {
      color: ${neutralForegroundRest};
      ${mixinRobotoFont()}
    }
  `;
};
